module.exports = "<i class=\"section-text\" ng-if=\"$ctrl.show\">\r\n    {{$ctrl.signalStrengthDescription}}\r\n</i>\r\n";